import axios from 'axios';
import { apiAddress } from '../../config';

/**
 * Fetch nearby audio track pins within a radius
 * @param {number} lat - Latitude
 * @param {number} lng - Longitude
 * @param {number} radiusKm - Search radius in kilometers (default 10)
 * @returns {Promise} API response with pins array
 */
export const fetchNearbyPins = async (lat, lng, radiusKm = 10) => {
  const response = await axios.get(`${apiAddress}/map/pins`, {
    params: {
      lat,
      lng,
      radius_km: radiusKm,
    },
  });
  return response.data;
};

/**
 * Fetch all tracks for a specific tour with GPS coordinates
 * @param {string} tourId - Tour UUID
 * @returns {Promise} API response with tour and tracks data
 */
export const fetchTourMap = async (tourId) => {
  const response = await axios.get(`${apiAddress}/map/tours/${tourId}`);
  return response.data;
};
